import React from 'react';
import { FaUniversity, FaMoneyCheckAlt, FaCreditCard, FaExchangeAlt, FaSyncAlt, FaCogs } from "react-icons/fa";
import './TallyFieldPage.css';

const BankReconciliation = () => {
  const sections = [
    {
      title: "Auto Bank Reconciliation",
      content: "Reconcile bank statements effortlessly by importing e-statements. Supports over 100 banks, automating the matching process to save time and reduce errors.",
      icon: <FaUniversity />,
    },
    {
      title: "Deposit Slips & Advice",
      content: "Generate cash and cheque deposit slips instantly. Simply provide the denominations, and TallyPrime handles the rest, streamlining your daily deposits.",
      icon: <FaMoneyCheckAlt />,
    },
    {
      title: "Cheque Management",
      content: "Track multiple cheque books with unique ranges for every bank. The integrated register helps you view, search, and monitor cheque clearance effortlessly.",
      icon: <FaCreditCard />,
    },
    {
      title: "Secure e-Payments",
      content: "A seamless interface between your bank and business. Make secure payments via e-Fund Transfer, Electronic Cheque, or DD directly from the portal.",
      icon: <FaExchangeAlt />,
    },
    {
      title: "Real-Time Synchronization",
      content: "Ensure your bank statements and accounting data are always in sync. Avoid discrepancies and make informed decisions with up-to-date records.",
      icon: <FaSyncAlt />,
    },
    {
      title: "Customizable Settings",
      content: "Tailor your banking workflow to your exact requirements. Configure reconciliation preferences, currencies, and payment limits with ease.",
      icon: <FaCogs />,
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Core Feature</span>
          <h1>Banking & Reconciliation</h1>
          <p>Simplify your financial operations with automated bank reconciliation and secure e-payment solutions.</p>
        </header>

        <div className="tally-field-grid">
          {sections.map((section, index) => (
            <div className="tally-field-card" key={index}>
              <div className="icon-wrapper">
                {section.icon}
              </div>
              <div className="card-content">
                <h3>{section.title}</h3>
                <p>{section.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BankReconciliation;
